export const productsHeader = [
  {
    id: 1,
    Header: '№',
    accessor: 'id',
    show: true,
    width: 30,
  },
  {
    id: 2,
    Header: 'Фамилия, Исм, Шариф',
    accessor: 'user_name',
    show: true,
    width: 250,
    type: 'name',
  },
  {
    id: 3,
    Header: 'Жами',
    accessor: 'total',
    type: 'info',
    show: true,
    width: 200,
    pl: 40,
    pr: 20,
  },
];

export const paymentsHeader = [
  {
    id: 1,
    Header: 'Фамилия, Исм, Шариф',
    accessor: 'user_name',
    show: true,
    sort: true,
    width: 300,
  },
  {
    id: 2,
    Header: 'Туман',
    accessor: 'region',
    show: true,
    width: 160,
    align: 'center',
  },
  {
    id: 3,
    Header: 'МФЙ',
    accessor: 'object',
    show: true,
    width: 150,
    // align: "center",
  },
  {
    id: 4,
    Header: 'Телефон рақами',
    accessor: 'phone',
    show: true,
    width: 150,
    // align: "center",
  },
  {
    id: 5,
    Header: 'Тизимдаги холати',
    accessor: 'logged',
    show: true,
    type: 'info',
    width: 160,
    align: 'center',
    // pl: 40,
    // pr: 20,
  },
  {
    id: 6,
    Header: 'Тўлов тугаш вақти',
    accessor: 'endDate',
    show: true,
    type: 'info',
    align: 'center',

    // width: 200,
    // pl: 40,
    // pr: 20,
  },
];
export const specialTasksHeader = [
  {
    id: 1,
    Header: 'Топшириқ номи',
    accessor: 'subCategory',
    show: true,
    width: 300,
  },
  {
    id: 2,
    Header: 'Жами ҳодимлар',
    accessor: 'user',
    show: true,
    width: 160,
  },
  {
    id: 3,
    Header: 'Бажармаган',
    accessor: 'plan',
    show: true,
    width: 150,
  },
  {
    id: 4,
    Header: 'Сана',
    accessor: 'date',
    show: true,
    width: 150,
  },
];
export const schedulesHeader = [
  {
    id: 1,
    Header: 'Фамилия, Исм, Шариф',
    accessor: 'user_name',
    show: true,
    sort: true,
    width: 300,
  },
  {
    id: 6,
    Header: 'Туман',
    accessor: 'region',
    show: true,
    width: 160,
    align: 'center',
  },
  {
    id: 7,
    Header: 'МФЙ',
    accessor: 'object',
    show: true,
    width: 150,
  },
  {
    id: 2,
    Header: 'Ҳаракатлар',
    accessor: 'came',
    show: true,
    type: 'info',
    width: 100,
    // pl: 40,
    // pr: 20,
  },
  {
    id: 3,
    Header: 'Вақти',
    accessor: 'comingTime',
    show: true,
    width: 160,
    // pl: 40,
    // pr: 20,
  },
  {
    id: 4,
    Header: 'Кеч қолди',
    accessor: 'lateTime',
    show: true,
    width: 100,
    sort: true,
    type: 'info',
    // pl: 40,
    // pr: 20,
  },
];

export const reportHeaderOrganization = [
  {
    Header: 'Т/р',
    columns: [
      {
        width: 50,
        Header: 'header_100',
        accessor: 'id',
        displayNone: true,
      },
    ],
    rowSpan: '2',
    show: true,
  },
  {
    Header: 'Ташкилот номи',
    columns: [
      {
        width: 150,
        accessor: 'name',
        Header: 'header_2',
        displayNone: true,
      },
    ],
    rowSpan: '2',
    show: true,
  },
];

export const reportHeader = [
  {
    Header: 'Т/р',
    columns: [
      {
        width: 50,
        Header: 'header_100',
        accessor: 'id',
        displayNone: true,
      },
    ],
    rowSpan: '2',
    show: true,
  },
  {
    Header: 'Шахар, туманлар номи',
    columns: [
      {
        width: 150,
        accessor: 'name',
        Header: 'header_2',
        displayNone: true,
      },
    ],
    rowSpan: '2',
    show: true,
  },
  // {
  //   Header: "Маҳаллабай, дафтарлар",
  //   show: true,
  //   height: 150,
  //   columns: [
  //     {
  //       Header: "Режа",
  //       accessor: "firstName",
  //     },
  //     {
  //       Header: "Амалда",
  //       accessor: "lastName",
  //     },
  //   ],
  // },
  // {
  //   Header: "Инвестиция,Экспорт,Бюджет",
  //   height: 150,
  //   show: true,
  //   columns: [
  //     {
  //       Header: "Режа",
  //       accessor: "age",
  //     },
  //     {
  //       Header: "Амалда",
  //       accessor: "visits",
  //     },
  //   ],
  // },
  // {
  //   Header: "Мурожаатлар,таълим",
  //   height: 150,
  //   show: true,
  //   columns: [
  //     {
  //       Header: "Режа",
  //       accessor: "age1",
  //     },
  //     {
  //       Header: "Амалда",
  //       accessor: "visits1",
  //     },
  //   ],
  // },
  // {
  //   Header: "Хизмат кўрсатиш",
  //   height: 150,
  //   show: true,
  //   columns: [
  //     {
  //       Header: "Режа",
  //       accessor: "age2",
  //     },
  //     {
  //       Header: "Амалда",
  //       accessor: "visits2",
  //     },
  //   ],
  // },
  // {
  //   Header: "“Обод қишлоқ”, “Обод махалла”",
  //   show: true,
  //   height: 150,
  //   columns: [
  //     {
  //       Header: "Режа",
  //       accessor: "age3",
  //     },
  //     {
  //       Header: "Амалда",
  //       accessor: "visits3",
  //     },
  //   ],
  // },
  // {
  //   Header: "Коммунал соҳа",
  //   height: 150,
  //   show: true,
  //   columns: [
  //     {
  //       Header: "Режа",
  //       accessor: "age4",
  //     },
  //     {
  //       Header: "Амалда",
  //       accessor: "visits4",
  //     },
  //   ],
  // },
  // {
  //   Header: "Бошқа масалалар",
  //   height: 150,
  //   show: true,
  //   columns: [
  //     {
  //       Header: "Режа",
  //       accessor: "age5",
  //     },
  //     {
  //       Header: "Амалда",
  //       accessor: "visits5",
  //     },
  //   ],
  // },
];
export const reportUserHeader = [
  {
    Header: 'Т/р',
    columns: [
      {
        Header: 'header_100',
        accessor: 'id',
        displayNone: true,
      },
    ],
    rowSpan: '2',
    show: true,
  },
  {
    Header: 'FISH',
    columns: [
      {
        accessor: 'name',
        Header: 'header_2',
        displayNone: true,
      },
    ],
    rowSpan: '2',
    show: true,
  },
];

export const statisticsHeader = [
  {
    Header: 'Т/р',
    show: true,
    height: 150,
    width: 50,
    accessor: 'id',
  },
  {
    Header: 'Худуд',
    show: true,
    height: 150,
    accessor: 'region',
  },
  {
    Header: 'Амалга оширилиши белгиланган ишлар сони',
    show: true,
    height: 150,

    accessor: 'plan_works',
  },
  {
    Header: 'Жами амалга оширилган ишлар сони	',
    show: true,
    height: 150,

    accessor: 'completed_works',
  },
  {
    Header: '%',
    show: true,
    height: 150,
    width: 100,
    accessor: 'percent',
  },
  {
    Header: 'Қуйилган бахо',
    show: true,
    height: 150,
    accessor: 'rating',
  },
];
